<template>
  <div class="d-flex flex-row flex-wrap gap-1">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      :class="['chip', { selected: isSelected(option.value) }]"
      @click="toggleSelected(option.value, $event.shiftKey)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Object,
    options: Array
  },
  data() {
    return {
      lastIndex: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    isSelected(value) {
      return this.modelValue[value] || false;
    },
    toggleSelected(value, withShiftKey) {
      let newSelection = {
        ...this.modelValue
      };
      const doSelect = !this.isSelected(value);
      let index = this.options.findIndex(option => option.value === value);
      let lastIndex = (withShiftKey ? this.lastIndex : null) ?? index;

      for (let i = Math.min(index, lastIndex); i <= Math.max(index, lastIndex); i++) {
        newSelection[this.options[i].value] = doSelect;
      }
      this.$emit('update:modelValue', newSelection);
      this.lastIndex = index;
    }
  }
}
</script>
